import { createApp } from 'vue'
import App from './App.vue'
import 'bulma/css/bulma.min.css'


createApp(App).mount('#app')
